export const SetterMutation = (stateProperties: string[]): any => {
	const mutations = {};
	for (const stateProperty of stateProperties) {
		const name = 'set' + stateProperty[0].toUpperCase() + stateProperty.substr(1);
		mutations[name] = function(state: any, value: any) {
			state[stateProperty] = value;
		}
	}
	return mutations;
};